import { truncateSelectedValues, formatSelections } from "./utils";
import { tagsData } from "@cinch-nx/data-search";
export const getFormattedTags = (tags = "")=>truncateSelectedValues(formatSelections(tags.toLowerCase(), tagsData));
